import React from "react";
import "./App.css";
import {EuiProvider, EuiThemeProvider} from "@elastic/eui";
import {Provider} from "react-redux";
import store from "./app/Store";
import {AuthenticationProvider} from "./authentication/AuthenticationProvider";
import {ElasticThemeBase} from "./styles/ElasticThemeBase";
import {DsRoutes} from "./Routes/DsRoutes";
import {LoadScript} from "@react-google-maps/api";
import config from "./app/config";

function App() {
    console.log(config.googleMaps.APIKEY)

    return (
        <EuiProvider colorMode={"light"}>
            <EuiThemeProvider theme={ElasticThemeBase}>
                <Provider store={store}>
                    <AuthenticationProvider>
                        <LoadScript googleMapsApiKey={config.googleMaps.APIKEY} libraries={['places']}>
                            <DsRoutes/>
                        </LoadScript>
                    </AuthenticationProvider>
                </Provider>
            </EuiThemeProvider>
        </EuiProvider>
    );
}

export default App;
